import toast from "react-hot-toast";
import  {client} from "@/app/ApolloClient";
import {gql} from "@apollo/client";


var query = gql`
  query GetAssetType($organizationId: UUID!, $assetTypeId: UUID!) {
    assetType(organizationId: $organizationId, id: $assetTypeId) {
      id
      name
      available_for_leasing
      description
      enable_deposit
      enable_one_time_payment
      enable_rent
      published
      regenerate_contracts_on_move
      require_vehicle
    }
  }
`;



export function apiGetAssetType(organizationId, assetTypeId) {
    return new Promise(async (resolve, reject) => {
        if(!organizationId) reject("organizationId is required");

        client
            .query({
                query: query,
                variables: {organizationId, assetTypeId},
                errorPolicy: "ignore",
                fetchPolicy: "network-only"
            })
            .then((result) => {
                resolve(result.data.assetType);
            })
            .catch((err) => {
                toast.error("Api Error, Unable to get asset type");
                reject(err); // R
            })
    });
}
